import actions from '@/core/store/anuencia/assinatura/actions.js'

export default {
	actions,
}
